import type { resolveProjectPaths } from '@next-adapter/config/paths/resolve-project-paths.js'
import { cleanupEmptyDirs, toProjectAbsolutePath } from '@cli-utils/paths.js'

export function cleanupSchemaEmptyDirs(
  cwd: string,
  deletedPaths: string[],
  configPaths: ReturnType<typeof resolveProjectPaths>
): void {
  cleanupEmptyDirs(cwd, deletedPaths, [
    toProjectAbsolutePath(cwd, configPaths.adminDir),
    toProjectAbsolutePath(cwd, configPaths.adminNavigationDir),
    toProjectAbsolutePath(cwd, configPaths.adminWebhookEventsDir),
    toProjectAbsolutePath(cwd, configPaths.pagesDir)
  ])
}
